// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/filepond/dist/filepond.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filepond--drop-label.filepond--drop-label label {
	align-items: center;
	background: var(--chakra-colors-darkBrandBlue-90);
	border-radius: 6px;
	color: var(--chakra-colors-white-100);
	cursor: pointer;
	display: flex;
	font-size: var(--chakra-fontSizes-sm);
	gap: 10px;
	padding: 10px 24px;
}

.filepond--drop-label.filepond--drop-label label img {
	max-height: 24px;
}

.filepond--file .filepond--file-status {
	display: flex;
	height: 100%;
	justify-content: flex-start;
}

.filepond--file-status .filepond--file-status-sub {
	display: none;
}

.filepond--item {
	list-style: none;
}

[data-filepond-item-state="processing"] .filepond--action-revert-item-processing {
	opacity: 0.7 !important;
	visibility: visible !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/blocks/FileUploadField/style.css"],"names":[],"mappings":"AAEA;CACC,mBAAmB;CACnB,iDAAiD;CACjD,kBAAkB;CAClB,qCAAqC;CACrC,eAAe;CACf,aAAa;CACb,qCAAqC;CACrC,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,2BAA2B;AAC5B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,8BAA8B;AAC/B","sourcesContent":["@import url(\"filepond/dist/filepond.min.css\");\n\n.filepond--drop-label.filepond--drop-label label {\n\talign-items: center;\n\tbackground: var(--chakra-colors-darkBrandBlue-90);\n\tborder-radius: 6px;\n\tcolor: var(--chakra-colors-white-100);\n\tcursor: pointer;\n\tdisplay: flex;\n\tfont-size: var(--chakra-fontSizes-sm);\n\tgap: 10px;\n\tpadding: 10px 24px;\n}\n\n.filepond--drop-label.filepond--drop-label label img {\n\tmax-height: 24px;\n}\n\n.filepond--file .filepond--file-status {\n\tdisplay: flex;\n\theight: 100%;\n\tjustify-content: flex-start;\n}\n\n.filepond--file-status .filepond--file-status-sub {\n\tdisplay: none;\n}\n\n.filepond--item {\n\tlist-style: none;\n}\n\n[data-filepond-item-state=\"processing\"] .filepond--action-revert-item-processing {\n\topacity: 0.7 !important;\n\tvisibility: visible !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
